<template lang="html">
	<div class="custom-select" :class="{solo: solo}">
		<div class="selected" @click.stop="display()">
			{{ displayValue(select) }}
			<span class="icon-arrow-full-down" :class="{deploy: show}"></span>
		</div>
		<div class="items" v-if="show">
			<div class="item" v-for="(item, eq) in items" v-bind:key="eq" @click.stop="setSelect(eq)">
				{{ displayValue(item) }}
			</div>
		</div>
	</div>
</template>

<script>
/*
 For now it support several things :
 v-model and default selected / change emit
 but for the well being of validation I started to
 make change into v-model value
*/

export default {
	name: 'custom-select',
	props: ['value', 'items', 'selected', 'solo', 'object', 'getter', 'debug'],
	data () {
		return {
			select: null,
			show: false,
			key: null
		}
	},
	mounted () {
		if (this.object) {
			this.key = this.getter || 'type'
		}
		if (this.selected) {
			this.select = this.selected
		} else {
			this.select = this.value || null
		}

		if (this.debug) {
			console.log('test', this.items)
		}
	},
	methods: {
		setSelect (key) {
			this.select = this.items[key]
			this.show = false
			this.$emit('change', this.items[key])
			this.$emit('input', this.items[key])
		},
		display () {
			this.show = !this.show
			if (this.show) {
				window.addEventListener('click', this.checkClick)
			}
		},
		checkClick (e) {
			this.show = false
			window.removeEventListener('click', this.checkClick)
		},
		displayValue (item) {
			if (item) {
				if (this.object) {
					const splitKey = this.key.split('.')
					if (splitKey.length === 1) {
						return item[this.key]
					} else {
						return item[splitKey[0]][splitKey[1]]
					}
				} else {
					return item
				}
			} else {
				return '-'
			}
		}
	},
	watch: {
		selected: function (value) {
			this.select = value
		},
		value: function (value) {
			this.select = value
		}
	}
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/common/components/Form/CustomSelect.vue